import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import React, { FC, ForwardedRef, forwardRef, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { DragAndDropProps } from "./DragAndDrop.types";
import './style.css';
import { Container, FooterButtons, GridThemeWrapper, StyledFooter, StyledFooterText, StyledHeader, StyledHeaderTitle } from '../Table/Table.styles';
import { InputButtonProps } from '../InputButton/InputButton.types';

const DragAndDrop: FC<DragAndDropProps> = forwardRef(
    (
        {
            height = '500px',
            width = '100px',
            showHeader = false,
            showFooter = true,
            headerTitle,
            headerButtons,
            footerButtons,
            returnedRecords,
            rowData,
            hasFilter,
            defaultColDef,
            gridApi,
            displayFooterButtons,
            columnDefs,
            getRowId,
            noRowsMessage,
            onCellEditRequest,
            readOnlyEdit,
            ...props
        },
        ref: ForwardedRef<AgGridReact>
    ) => {
        const [displayedRowCount, setDisplayedRowCount] = useState<number | undefined>(returnedRecords);

        const [internalDefaultColDef, setInternalDefaultColDef] = useState({
            resizable: true,
            sortable: true,
            filter: hasFilter ?  'agTextColumnFilter' : null,
            floatingFilter: hasFilter ?  true : false,
            filterParams: {
              readOnly: returnedRecords === 0 ? true : false,
            },
          });
          // updates the filter state when returnedRecords changes
          useEffect(() => {
            setInternalDefaultColDef({
              ...internalDefaultColDef,
              filterParams: {
                readOnly: returnedRecords === 0 ? true : false,
              },
            });
            gridApi?.refreshHeader();
            setDisplayedRowCount(returnedRecords);
          }, [returnedRecords]);
         
          const getGridWrapper = () => (
            <div className="panel panel-primary" style={{ marginRight: "40px" }}>
              <div className='panel-body' style={{ height: "100%" }}>
                <Container className='ag-theme-alpine' height={height} width={width}>
                <StyledHeader data-testid='header'>
                  <StyledHeaderTitle>{headerTitle}</StyledHeaderTitle>
                </StyledHeader>
                <GridThemeWrapper
                   height={height}
                   showHeader={showHeader}
                   showFooter={showFooter}
                   headerInputButton={
                     headerButtons &&
                     headerButtons?.length > 0 &&
                     (headerButtons[0] as InputButtonProps)?.buttonProps !== undefined
                   }>
                <AgGridReact
                  data-testid='ag-grid-react'
                  {...props}
                  ref={ref}
                  defaultColDef={defaultColDef ? defaultColDef : internalDefaultColDef}
                  rowDragManaged={false}
                  animateRows={true}
                  getRowId={getRowId}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  stopEditingWhenCellsLoseFocus={true}
                  onCellEditRequest={onCellEditRequest}
                  readOnlyEdit={readOnlyEdit}
                  rowDragEntireRow={true}
                />
                </GridThemeWrapper>

              {showFooter && footerButtons && footerButtons.length >= 3 ? (
              <FooterButtons>{displayFooterButtons}</FooterButtons>
        ) : (
          <></>
        )}
        {showFooter && (
          <StyledFooter footerButtons={footerButtons}>
            {footerButtons && footerButtons.length < 3 && displayFooterButtons}
            <StyledFooterText>
              {`${displayedRowCount === undefined ? 0 : displayedRowCount} ${displayedRowCount === 1 ? 'record' : 'records'}`}
            </StyledFooterText>
          </StyledFooter>
        )}
                </Container>
              </div>
            </div>
          );

        return (
            <div className='top-container' >
            <div className=" grid-wrapper">
              {getGridWrapper()}
            </div>
          </div>
        );  
    }
);

export default DragAndDrop;

